import { t } from '../i18n/nl.js';

// Publieke, niet-ingelogde informatiepagina over accountverwijdering.
// Harde Google Play-eis: de "Account verwijderen"-URL in de Play Console
// moet zonder inloggen bereikbaar zijn. Deze route staat daarom bewust
// BUITEN <ProtectedRoute> in App.jsx (zelfde plek als /overeenkomst/:token
// en /betaling-bevestiging/:invoiceId).
//
// Puur statisch: geen formulier, geen Supabase-aanroep. De stappen onder
// "met app-toegang" spiegelen de daadwerkelijke flow in de mobiele app
// (InstellingenScreen → sectie "Account verwijderen" → modal met
// e-mailbevestiging → RPC delete_client_account via EF
// delete-client-account).

const ONDERSTEUNINGSADRES = '[PLACEHOLDER: ondersteuningsadres]';

function Sectie({ titel, children }) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 17, fontWeight: 600, color: '#111827', marginBottom: 10 }}>
        {titel}
      </h2>
      {children}
    </section>
  );
}

const pStyle = { color: '#374151', fontSize: 15, lineHeight: 1.65, marginBottom: 12 };
const liStyle = { color: '#374151', fontSize: 15, lineHeight: 1.65, marginBottom: 6 };
const listStyle = { paddingLeft: 22, marginBottom: 12 };

export default function AccountVerwijderenPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#f9fafb',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: '32px 16px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: 12,
        padding: '36px 28px',
        maxWidth: 720,
        margin: '0 auto',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 8 }}>
          {t('accountVerwijderen.titel')}
        </h1>
        <p style={{ ...pStyle, marginBottom: 28 }}>{t('accountVerwijderen.intro')}</p>

        <Sectie titel={t('accountVerwijderen.metAppTitel')}>
          <p style={pStyle}>{t('accountVerwijderen.metAppIntro')}</p>
          <ol style={listStyle}>
            <li style={liStyle}>{t('accountVerwijderen.metAppStap1')}</li>
            <li style={liStyle}>{t('accountVerwijderen.metAppStap2')}</li>
            <li style={liStyle}>{t('accountVerwijderen.metAppStap3')}</li>
            <li style={liStyle}>{t('accountVerwijderen.metAppStap4')}</li>
          </ol>
          <p style={{ ...pStyle, color: '#6b7280', fontSize: 14 }}>
            {t('accountVerwijderen.metAppLet')}
          </p>
        </Sectie>

        <Sectie titel={t('accountVerwijderen.zonderAppTitel')}>
          <p style={pStyle}>{t('accountVerwijderen.zonderAppIntro')}</p>
          <p style={{
            ...pStyle,
            background: '#f3f4f6',
            borderRadius: 8,
            padding: '12px 14px',
            fontWeight: 600,
            wordBreak: 'break-word',
          }}>
            {ONDERSTEUNINGSADRES}
          </p>
          <p style={pStyle}>{t('accountVerwijderen.zonderAppVermeld')}</p>
          <ul style={listStyle}>
            <li style={liStyle}>{t('accountVerwijderen.zonderAppVermeld1')}</li>
            <li style={liStyle}>{t('accountVerwijderen.zonderAppVermeld2')}</li>
            <li style={liStyle}>{t('accountVerwijderen.zonderAppVermeld3')}</li>
          </ul>
          <p style={{ ...pStyle, color: '#6b7280', fontSize: 14 }}>
            {t('accountVerwijderen.zonderAppTermijn')}
          </p>
        </Sectie>

        <Sectie titel={t('accountVerwijderen.gevolgenTitel')}>
          <ul style={listStyle}>
            <li style={liStyle}>{t('accountVerwijderen.gevolg1')}</li>
            <li style={liStyle}>{t('accountVerwijderen.gevolg2')}</li>
            <li style={liStyle}>{t('accountVerwijderen.gevolg3')}</li>
            <li style={liStyle}>{t('accountVerwijderen.gevolg4')}</li>
          </ul>
        </Sectie>

        <Sectie titel={t('accountVerwijderen.bewaarTitel')}>
          <p style={pStyle}>{t('accountVerwijderen.bewaarUitleg')}</p>
          <p style={pStyle}>{t('accountVerwijderen.bewaarScheiding')}</p>
        </Sectie>

        <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6, marginTop: 28 }}>
          {t('accountVerwijderen.vragen')}
        </p>
      </div>
    </div>
  );
}
